import {Avatar, Link} from "@material-ui/core";
import David from "../assets/images/david.jpg";
import Ben from "../assets/images/ben.jpg";
import React from "react";
import tw from "twin.macro";
import Comparison from "./Comparison";
import { LinkedIn } from "@material-ui/icons";

const Container = tw.div`flex justify-center items-center pt-12 mt-20`;
const ContainerMobile = tw.div`flex items-center justify-between pt-12`;

function AboutUs(props) {
    const { isMobile } = props;
    const UseContainer = isMobile ? ContainerMobile : Container;
    return (
        <>
            <UseContainer>
                <div className={isMobile ? 'subpageBlockMobile' : 'subpageBlock'}>
                    <div style={{textAlign: 'center', paddingLeft: isMobile ? undefined : '6rem'}}>
                        <Avatar src={David} style={{width: '9rem', height: '9rem', margin: "auto"}}/>
                        <h3 style={{paddingTop: '0.5rem', marginTop: '0.6rem', margin: "auto"}}>
                            David Israel
                        </h3>
                        <h5 style={{padding: '0', marginBottom: '0', margin: "auto"}}>Co-Founder</h5>
                    </div>
                    <div style={{textAlign: 'center'}}>
                        <Link href="https://www.linkedin.com/company/uclusion" target="_blank">
                            <LinkedIn fontSize='large' />
                        </Link>
                    </div>
                    <div style={{textAlign: 'center', paddingRight: isMobile ? undefined : '6rem'}}>
                        <Avatar src={Ben} style={{width: '9rem', height: '9rem', margin: "auto"}}/>
                        <h3 style={{paddingTop: '0.5rem', marginTop: '0.6rem', margin: "auto"}}>
                            Ben Follis
                        </h3>
                        <h5 style={{padding: '0', marginBottom: '0', margin: "auto"}}>Co-Founder</h5>
                    </div>
                </div>
            </UseContainer>
            <Comparison />
            <div style={{paddingBottom: isMobile ? '2rem' : undefined}} />
        </>
    );
}

export default AboutUs;